import { parseISO, format, isValid } from 'date-fns';
import { ptBR } from 'date-fns/locale';

/**
 * Formata uma data no formato 'dd/MM/yyyy HH:mm'.
 * @param {string | null} dataAniversario - A data em formato ISO ou string, ou null.
 * @returns {string} - A data formatada ou uma string vazia caso a entrada seja inválida.
 */
export default function FormatarData(dataAniversario: string | null, type?: string): string {
  if (!dataAniversario) {
    return ''; // Retorna vazio se for null ou string vazia
  }

  try {
    const parsedDate = parseISO(dataAniversario);

    // Verifica se a data é válida
    if (!isValid(parsedDate)) {
      return ''; // Retorna vazio se a data for inválida
    }

    if(type === 'default'){
      return format(parsedDate, 'dd MMM, yyyy', { locale: ptBR });
    } else if(type === 'only-month'){
      return format(parsedDate, 'MMM', { locale: ptBR });
    } else if(type === 'day-month'){
      return format(parsedDate, 'dd MMM', { locale: ptBR });
    }
    return format(parsedDate, 'dd MMM, yyyy - HH:mm', { locale: ptBR });
  } catch (error) {
    console.error('Erro ao formatar a data:', error);
    return ''; // Retorna vazio em caso de erro
  }
}
